import * as React from "react";
import type { useAffinityFormReturn } from "affinityForm";

import { PatientFormData, UpdatePatientFormData } from "./types";

export const PatientsFormContext = React.createContext<Maybe<useAffinityFormReturn<PatientFormData>>>(null);
export const PatientsUpdateFormContext = React.createContext<Maybe<useAffinityFormReturn<UpdatePatientFormData>>>(null);
